/*
 * @Author: bobo 350910378@qq.com
 * @Date: 2023-02-28 15:53:54
 * @LastEditors: bobo 350910378@qq.com
 * @LastEditTime: 2024-11-21 21:08:52
 * @FilePath: \baishu_react_ui\src\utils\WidgetFilter\AddressWidgetFilter.jsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import WidgetFilter from ".";

import get from "lodash/get";
import negate from "lodash/negate";
import includes from "lodash/includes";
import size from "lodash/size";

import { BsyUtils } from "../Utils";
import { BsyConfig } from "../../global/BsyConfig";
import { dayjsUtils } from "../dayjsUtils";

export default class DatetimeWidgetFilter extends WidgetFilter {
    _isConfigValid() {
        var t = this.options
            , e = BsyConfig().CONST.FILTER_METHOD;
        if (-1 < [e.EQ, e.NE, e.GTE, e.LTE].indexOf(t.method)) {
            e = get(t.value, "[0]");
            return size(t.value) <= 1 && BsyUtils.isString(e) && !BsyUtils.isObjectEmpty(e)
        }
        return !0
    }
    eq(t) {
        var e = BsyUtils.getFormulaTimeRange(t);
        return function (t) {
            t = t ? dayjsUtils.timeToTZ(t).getTime() : null;
            return !!t && (t >= e.min && t <= e.max)
        }
    }

    ne(t) {
        return negate(this.eq(t))
    }

    gte(t) {
        var e = null;
        switch (t) {
            case "today":
            case "yesterday":
            case "thisWeek":
            case "lastWeek":
            case "thisMonth":
            case "lastMonth":
            case "tomorrow":
            case "nextMonth":
            case "nextWeek":
            case "thisQuarterly":
            case "lastQuarterly":
            case "nextQuarterly":
            case "nextYear":
            case "thisYear":
            case "lastYear": {
                let t1 = BsyUtils.getFormulaTimeRange(t);
                e = t1.min;
                break
            }
            default:
                e = dayjsUtils.timeToTZ(t).getTime();
        }

        return function (t) {
            t = t ? dayjsUtils.timeToTZ(t).getTime() : null;
            return !(!t || !e) && e <= t
        }
    }
    lte(t) {
        var e = null;
        switch (t) {
            case "today":
            case "yesterday":
            case "thisWeek":
            case "lastWeek":
            case "thisMonth":
            case "lastMonth":
            case "tomorrow":
            case "nextMonth":
            case "nextWeek":
            case "thisQuarterly":
            case "lastQuarterly":
            case "nextQuarterly":
            case "nextYear":
            case "thisYear":
            case "lastYear": {

                let t1 = BsyUtils.getFormulaTimeRange(t);
                e = t1.max;
                break
            }
            default:
                t = t ? dayjsUtils.timeToTZ(t).getTime() : null;
                e = t ? BsyUtils.getUpperTimeLimit(t) : null;
        }

        return function (t) {
            t = t ? dayjsUtils.timeToTZ(t).getTime() : null;
            return !(!t || !e) && t <= e
        }
    }
    range(t, e) {
        var i = t ? dayjsUtils.timeToTZ(t).getTime() : null;
        var a = e ? dayjsUtils.timeToTZ(e).getTime() : null;
        return function (t) {
            var e = t ? dayjsUtils.timeToTZ(t).getTime() : null;
            if (!e)
                return !1;
            t = !i || i <= e;
            return t = a ? t && e <= a : t
        }
    }
    formula(t, t1) {
        let d1 = t;
        switch (t) {
            case "today":
            case "yesterday":
            case "thisWeek":
            case "lastWeek":
            case "thisMonth":
            case "lastMonth":
            case "tomorrow":
            case "nextMonth":
            case "nextWeek":
            case "thisQuarterly":
            case "lastQuarterly":
            case "nextQuarterly":
            case "nextYear":
            case "thisYear":
            case "lastYear": {

                break
            }
            default:
                d1 = {
                    method: "formula",
                    value: [t, t1]
                }
        }

        var i = BsyUtils.getFormulaTimeRange(d1);
        return function (t) {
            var e = t ? dayjsUtils.timeToTZ(t).getTime() : null;
            if (!e)
                return !1;
            t = !0;
            return i.min && (t = e >= i.min),
                t = i.max ? t && e <= i.max : t
        }
    }
    empty() {
        var e = this;
        return function (t) {
            return includes(e._getNullValues(), t)
        }
    }
    notEmpty() {
        return negate(this.empty())
    }
}
